import { StyleSheetManager, ThemeProvider } from 'styled-components';

import { shouldForwardStyledProp } from '@/js/libs/styled-components';
import { Loader, palette } from '@/js/libs/ui';

import 'src/api.ts';
import { Notification } from 'src/modules/Notification/index.tsx';
import { ThemeControllerProvider, useThemeController } from 'src/theme/ThemeController.tsx';
import { AppRouter } from './AppRouter.tsx';
import { AppSuspense } from './components/AppSuspense/index.ts';
const ThemedApp = () => {
  const { themeId } = useThemeController();
  return (
    <StyleSheetManager shouldForwardProp={shouldForwardStyledProp}>
      <ThemeProvider theme={palette[themeId]}>
        <Notification />
        <AppSuspense fallback={<Loader type='initial' />}>
          <AppRouter />
        </AppSuspense>
      </ThemeProvider>
    </StyleSheetManager>
  );
};

export const App = () => (
  <ThemeControllerProvider>
    <ThemedApp />
  </ThemeControllerProvider>
);
